// src/components/IconSelector/IconSelector.js
import React from 'react'
import Select from 'react-select'
import { iconosFontAwesome } from './iconos'
import './IconSelector.css'

const IconSelector = ({ value, onChange, placeholder = 'Buscar ícono...' }) => {
	// Encontrar la opción seleccionada
	const selectedOption = iconosFontAwesome.find(i => i.value === value) || null

	// Determinar el prefijo correcto (fab para marcas, fas para el resto)
	const getIconClass = (iconValue, isBrand) => {
		const prefix = isBrand ? 'fab' : 'fas'
		return `${prefix} ${iconValue}`
	}

	// Renderizar cada opción con el ícono
	const formatOptionLabel = ({ value, label, brand }) => (
		<div className="icon-option">
			<i className={getIconClass(value, brand)} />
			<span>{label}</span>
		</div>
	)

	// Renderizar el valor seleccionado
	const formatSingleValue = ({ value, label, brand }) => (
		<div className="icon-selected">
			<i className={getIconClass(value, brand)} />
			<span>{label}</span>
		</div>
	)

	const handleChange = (option) => {
		onChange(option?.value || '')
	}

	// Estilos personalizados para react-select
	const customStyles = {
		control: (base) => ({
			...base,
			minHeight: '38px',
		}),
		option: (base, state) => ({
			...base,
			backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : 'white',
			color: state.isSelected ? 'white' : '#212529',
			cursor: 'pointer',
		}),
		menu: (base) => ({
			...base,
			zIndex: 9999,
		}),
	}

	return (
		<Select
			className="icon-selector"
			classNamePrefix="icon-selector"
			options={iconosFontAwesome}
			value={selectedOption}
			onChange={handleChange}
			formatOptionLabel={formatOptionLabel}
			formatSingleValue={formatSingleValue}
			isSearchable
			isClearable
			placeholder={placeholder}
			noOptionsMessage={() => 'No se encontraron íconos'}
			styles={customStyles}
		/>
	)
}

export default IconSelector
